import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Company } from '../../../models/Company.model';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { CompaniesService } from '../../../services/companies.service';
import {ConsultantService} from '../../../services/consultant.service';
import { ProductService } from '../../../services/product.service';
import { OwnerService } from '../../../services/billing-letter/owner.service';
import { Owner } from '../../../models/billing-letter/Owner.model';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { CompanyGroupSearch } from "../../../models/CompanyGroupSearch.model";
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl  } from '@angular/forms';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ToastsManager } from "ng2-toastr";
import { HashtrackService } from "../../../services/hashTrack.service";
import { AwsService } from '../../../services/aws.service';
import { BankService } from '../../../services/bank.service';
import { DropDownList } from '../../../models/DropDownList.model';
import { ExternalReferenceFinancial } from '../../../models/ExternalReference.model';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { GUARDS } from '../../../shared/auth/Roles';
import * as moment from 'moment';
import * as _ from 'lodash';
import { CompanyContract } from '../../../models/CompanyContract.model';
import { NewContractTypesEnum } from '../../../shared/enums/ContractType.enum';
// import {ConsultantSearch} from "../../../models/ConsultantSearch.model";
// import { PixKeyType } from '../../../shared/enums/PixKeyType';
// import { PaymentType } from '../../../shared/enums/PaymentType';
// import { PixValidation } from '../../../shared/helpers/PixValidation';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { IndustriesService } from '../../../services/industries.service';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { UserService } from '../../../services/user.service';
import { Industry } from '../../../models/Industry.model';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { Responsible } from '../../../models/Responsible.model';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { CnaeService } from '../../../services/cnae.service';


moment.locale('pt-br');
@Component({
  selector: 'app-companies-edit',
  templateUrl: './companies-edit.component.html',
  styleUrls: ['./companies-edit.component.css']
})
export class CompaniesEditComponent implements OnInit {
  @ViewChild("buttonOpenModalContract") buttonOpenModalContract: ElementRef;
  hashCustomers;
  emails: string[];
  name: string;
  companyForm: FormGroup;
  company: Company = new Company();
  cnpjPattern = /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/i;
  mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
  cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
  agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
  digitMask = [/[A-Za-z0-9]/];
  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] ;
  contractNotificationPattern = /([A-Za-z ])|[^\w\s]/gi;
  numberPattern = [/[0-9]/,'.',/[0-9]/,/[0-9]/];
  commonHelper: CommonHelper = new CommonHelper();
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  companyGroupSearchModel: CompanyGroupSearch;
  loading: boolean;
  DropDownHash: DropDownList[] = new Array<DropDownList>();
  DropDownSettings = {};
  selectedHash: DropDownList[] = new Array<DropDownList>();
  industries: Industry[] = new Array<Industry>();
  excellenceCenters: ExcellenceCenter[] = new Array<ExcellenceCenter>();
  fileList;
  fileListCompanyTemporary;
  fileListRegisterFiles;
  selectedFiles:FileList;
  downloadUrl:string = '';
  contractNotificationDefaultValue: Number;
  banks : any = [];
//   pixKeyVerifyMethod : any;
//   pixKeyFlag: Boolean = true;
//   pixCpfValid : Boolean;
//   pixCnpjValid : Boolean;
  phoneMaskFlag: Boolean = false;
  canPreviewDocument: boolean = false;
  typeContractModal: string = '';
  funcContractModal: Function;
  hidePrivateData: Boolean = false;
  restCaracters: number;

  GUARDS = GUARDS;
  canSave: Boolean = true;
  allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.JUDICIARY, GUARDS.DP, GUARDS.BILLSRECEIVE];
  user;
  newContractPreview: any;

  items = [];
  itemsDropdown = {
    list: [],
    options: null,
    selected: []
  };
  contractTypes: any[] = [];
  contractTypeGroup: any[] = [];
  readjustmentQuoeficient: any[] = [];
  textMask;
  selectedContract: CompanyContract = new CompanyContract();
  isSubscriberFieldEmpty: boolean = false;
  redirect: Boolean = true;

  constructor(private companiesService: CompaniesService,
    private productService: ProductService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private tostr: ToastsManager,
    private awsService:AwsService,
    private hashtrackService: HashtrackService,
    private dropDownItemFactory: DropdownItemFactory,
    private dropDownSettingFactory: DropdownSettingsFactory,
    private industriesService: IndustriesService,
    private excellenceCentersService: ExcellenceCentersService,
    private localStorage: LocalStorage,
    private bankService: BankService,
    // private newContractTypeEnum: NewContractTypesEnum,
    // public pixValidation: PixValidation,
    private errorHandler: ErrorHandlerProvider,
    private cnaeService: CnaeService
  ) { }

  async ngOnInit() {

    this.loading = true;

    this.checkPermissions();

    this.companyForm = this.formBuilder.group({
      name: [null, Validators.required],
      companyName: [null, Validators.required],
      companyGroup: [null, [this.validateSelectOption]],
      industry: [null, [this.validateSelectOption]],
      cnpj: [null, [Validators.required, Validators.pattern(this.cnpjPattern)]],
      emails: [null, Validators.required],
    //   keyPix:[null,[this.validateKeyPix]]
    });

    this.readjustmentQuoeficient = this.commonHelper.getAllReadjustmentQuoeficientGroups();

    const company = await this.companiesService.getById(this.route.snapshot.params["id"]);
    this.company = company;
    this.industries = await this.industriesService.getAll();
    this.excellenceCenters = await this.excellenceCentersService.getAll();
    this.hashCustomers = await this.hashtrackService.getAllCustomers();
    this.DropDownHash = this.commonHelper.getDropDownListItems(this.hashCustomers, "_id", "name");
    this.DropDownSettings = this.commonHelper.getDropDownSettings(true, "Cliente", false, "", "", true,null, "");
    this.companyGroupSearchModel = new CompanyGroupSearch();
    this.companyGroupSearchModel.allItems = true;
    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);

    this.banks = await this.bankService.getBanks();

    if(this.company.start){
      const formatStartDate = moment(this.company.start).format("DD/MM/YYYY");
      this.company.start = formatStartDate;
      this.company = new Company({...this.company, start: formatStartDate});
    }

    if(this.company.end){
      const formatEndDate = moment(this.company.end).format("DD/MM/YYYY");
      this.company.end = formatEndDate;
      this.company = new Company({...this.company, end: formatEndDate});
    }

    if (this.company.externalReference) {
        let companyHT = this.DropDownHash.find(x => x.id == this.company.externalReference._id);
      if (companyHT) {
        let ddl = new DropDownList();
        ddl.id = company.externalReference._id;
        ddl.itemName = companyHT.itemName;
        this.selectedHash.push(ddl);
      }
    } else
      this.selectedHash = null;

    await this.getS3Files();
    if(this.fileList.length > 0){
      this.download(this.fileList[0].Key);
    }


    if(!this.company.isCustomer) {
        this.items = await this.cnaeService.getAllItems([SapItemType.ItemPurchaseOrder]);
        this.items = _.orderBy(this.items,[item => item.name.toUpperCase()]);
        this.itemsDropdown.options = this.dropDownSettingFactory.build({text:'Item do pedido',singleSelection:false,enableCheckAll:false});
        this.itemsDropdown.list = this.dropDownItemFactory.build({source:this.items});
        this.company.defaultItems.forEach(item => {
            const itemDropDown = this.itemsDropdown.list.find(i => i.sapItemCode === item);
            if(itemDropDown) this.itemsDropdown.selected.push(itemDropDown);
        });
    }

    // if(this.pixKeyFlag){
    //   this.pixKeyFlag = false;
    // }

    // if(!this.company.payment.typePix) {
    //   this.company.payment.typePix = 0
    //   this.companyForm.get("keyPix").disable();
    // }


    // if(this.company.payment.keyPix){
    //   this.textMask = {mask: false}
    // }

    if (this.user.permission == GUARDS.RS) {
      this.hidePrivateData = true ;
    }

    if(this.company && this.company.isCustomer) {
      this.companyForm.get("companyGroup").enable();
      this.companyForm.get("industry").enable();
    } else {
      this.companyForm.get("companyGroup").disable();
      this.companyForm.get("industry").disable();
    }

    this.loading = false;
  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    if(!this.allowedRoles.includes(this.user.permission)) {
        this.canSave = false;
    }
  }


  async OnSave() {
    try{

        // if(!this.company.payment.keyPix && this.company.payment.typePix != 0){
        //   this.tostr.warning("A chave pix é obrigatória")
        //   return;
        //   }

        if (this.companyForm.valid) {
            if(this.company.companyName.length > 100)
                return this.tostr.warning('O nome da empresa é longo demais, permitido apenas 100 caracteres!');

            if (this.selectedHash && this.selectedHash.length > 0) {
                this.company.externalReference = new ExternalReferenceFinancial();
                this.company.externalReference._id = this.selectedHash[0].id;
                this.company.externalReference.name = this.selectedHash[0].itemName;
            } else
                this.company.externalReference = null;

            if(this.company.industry)
                this.company.industry = this.industries.find(x => x._id === this.company.industry._id);

            if(this.company.companyGroup._id != '' && this.company.companyGroup._id != undefined)
                this.company.companyGroup.name = this.companyGroups.find(x => x._id === this.company.companyGroup._id).name;

            if(!this.company.isCustomer && this.itemsDropdown.selected.length > 0){
                const itemsSelected = this.itemsDropdown.selected.map(item => {
                    return item.sapItemCode;
                });
                this.company.defaultItems = itemsSelected;
            }
            this.loading = true;
            let response = await this.companiesService.edit(this.company);
            if(this.redirect) {
                this.loading = false;
                if(response._id){
                    this.tostr.success('Empresa atualizada com sucesso!');
                    this.router.navigate(['/companies']);
                } else {
                    this.errorHandler.interceptError(response, 'Empresa');
                }
            } else {
                this.redirect = true;
                return response;
            }
        }

    } catch(err){
        this.loading = false;
        this.errorHandler.interceptError(err, 'Empresa');
    }
  }

  verifyValidTouched(fieldName) {
    return !this.companyForm.get(fieldName).valid && this.companyForm.get(fieldName).touched;
  }

  validateSelectOption(control: AbstractControl) {
      if (control.value == 0 || control.value == '0' ||
          control.value == 'undefined' || control.value == undefined)
          return {valid: true};
      return null;
  }

//   trim(){
//     if(this.company.payment.keyPix)
//         this.company.payment.keyPix = this.company.payment.keyPix.trim();
//   }

  async verifyCNPJ(){
    if(this.company.cnpj == '' || this.company.cnpj == undefined) {
        this.tostr.warning('CNPJ não pode ser vazio');
    } else {
        let response = await this.companiesService.verifyCnpj(this.company);
        if(response.length > 0){
            this.tostr.warning(`O CNPJ está cadastrado para o cliente ${response[0].name?response[0].name:""}`,'CNPJ em uso!');
            this.company.cnpj = '';
        } else {
            await this.cnpjSearch();
        }
    }
  }

  async cnpjSearch(){
    try {
      let cnpj = this.company.cnpj;
      if(cnpj == '')
          return this.tostr.warning('CNPJ não pode ser vazio!');
      if(!this.companiesService.cnpjValid(cnpj))
          return this.tostr.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');

      this.tostr.warning('Realizando consulta ao CNPJ...');
      cnpj = cnpj.trim();

      let response = await this.companiesService.getCnpj(this.company.cnpj);
      if(response.success) {
          this.company.name = response.fantasia;
          this.company.companyName = response.nome;
          this.company.address.street = response.logradouro;
          this.company.address.number = response.numero;
          this.company.address.complement = response.complemento;
          this.company.address.city = response.municipio;
          this.company.address.uf = response.uf;
          this.company.address.district = response.bairro;
          this.company.address.zipCode = response.cep;
          this.company.address.type = response.tipo;
      } else {
          this.errorHandler.interceptError(response, 'Empresa');
      }
    } catch(err) {
      this.errorHandler.interceptError(err, 'Empresa');
    }
  }

//   async verifyCPFCNPJPixKey(){
//     if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
//         this.tostr.warning("O CPF/CNPJ é obrigatório!");
//         this.company.payment.keyPix = "";
//     } else if(this.commonHelper.cpfValidator(this.company.payment.keyPix)){
//         this.pixCpfValid = true;
//     } else if(this.companiesService.cnpjValid(this.company.payment.keyPix)){
//       this.pixCnpjValid = true;
//     }else if(!this.pixCnpjValid && !this.pixCpfValid){
//       this.tostr.warning('CPF/CNPJ inválido.');
//       this.company.payment.keyPix = "";
//     }
//   }

cnpjValid(cnpj: String) {
    return this.companiesService.cnpjValid(cnpj);
}

async getCnpj(cnpj: String) {
    return await this.companiesService.getCnpj(cnpj);
}

// randomPixKeySearch(){
//     if(this.company.payment.keyPix == '' || this.company.payment.keyPix == undefined) {
//         this.tostr.warning('Aleatório não pode ser vazio');
//     } else if (!this.consultantService.randomPixKeyValid(this.company.payment.keyPix)) {
//         this.tostr.warning('Aleatório inválido. Aleatório deve ter 36 caracteres!');
//         this.company.payment.keyPix = ''
//     }
// }

// async verifyEmailPixKey(){
//     this.trim();

//     if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
//      this.tostr.warning("O Email é obrigatório!");
//      this.company.payment.keyPix = "";
//     }else{
//       if (!(new RegExp(this.emailPattern).test((this.company.payment.keyPix).toString()))) {
//         this.tostr.warning(`Digite um email válido.`, "Email inválido!");
//         this.company.payment.keyPix = "";
//       }
//     }
// }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }
  verifyDate(date,field){
    if(!(new RegExp(this.datePattern).test(date))){
        this.tostr.warning(`Digite uma data válida.`,"Data inválida!");
        this.company[`${field}`] = "";
    }
  }

  verifyContractNotificationValue(value, field){
    if(value <= 0 || new RegExp(this.contractNotificationPattern).test(value)){
        this.tostr.warning(`Valor para o lembrete de encerramento de contrato
        não pode ser negativo, valor anterior será mantido`, "Valor inválido!");
        this.company[`${field}`] = this.contractNotificationDefaultValue;
    }
}

  async getS3Files(){
    this.fileList = await this.awsService.getFiles(this.company._id);
    this.fileListCompanyTemporary = await this.awsService.getFiles(`company-temporary/${this.company.companyTemporaryId}`);
    this.fileListRegisterFiles = await this.awsService.getFiles(`register-files/${this.company._id}`);
  };

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  async deleteFile(name){
    await this.awsService.deleteFile(name);
    await this.getS3Files();
  }

  async upload() {
    try {
      let id = this.company._id;
      let length = this.selectedFiles.length;
      for(let i=0; i<length; i++){
        const file = this.selectedFiles.item(i);
        await this.awsService.uploadfile(file,id);
      }

      await this.getS3Files();
      this.selectedFiles = null;
    } catch (error) {
      this.errorHandler.interceptError(error, 'Empresa');
    }
 }

    async uploadRegisterFiles() {
        try {
            let id = this.company._id;
            let length = this.selectedFiles.length;
            for(let i=0; i<length; i++){
            const file = this.selectedFiles.item(i);
            await this.awsService.uploadfile(file,`register-files/${id}`);
            }

            await this.getS3Files();
            this.selectedFiles = null;
        } catch (error) {
            this.errorHandler.interceptError(error, 'Empresa');
        }
    }

    async download(name){
        this.downloadUrl = await this.awsService.download(name);
    }

    emailBlur() {
        this.tostr.warning('Aperte ENTER para confirmar a inserção do e-mail');
    }

    async finalizeRegistration() {
        const files = [
            ...this.fileList.map(file => this.awsService.getPuclicPath() + file.Key),
            ...this.fileListRegisterFiles.map(file => this.awsService.getPuclicPath() + file.Key),
            ...this.fileListCompanyTemporary.map(file => this.awsService.getPuclicPath() + file.Key),
        ];

        const data = {
            company: { ...this.company },
            files,
            finalizeWithoutContract: this.fileList.length > 0 ? true : false
        };

        try {
            this.loading = true;
            let response = await this.companiesService.finalizeRegistration(data);
            if(response._id) {
                this.loading = false;
                this.tostr.success("Cadastro de empresa finalizado com sucesso");
                this.router.navigate(['/companies']);
            } else {
                this.loading = false;
                this.errorHandler.interceptError(response, 'Empresa');

            }
        } catch(err) {
            this.loading = false;
            this.errorHandler.interceptError(err, 'Empresa');
        }
    }

//     onPixTypeChange() {
//       this.pixValidation.onPixTypeChange(this.company.payment.typePix, this.companyForm.get("keyPix"))
//       this.textMask = {mask: false}
//   }

//   async verifyPixKey(){
//     if (!this.company.payment.typePix) {
//         return
//     }
//     this.pixCpfValid = false;
//     this.pixCnpjValid = false;

//     let typePix = this.company.payment.typePix

//     switch (typePix) {
//         case PixKeyType.phone:
//             if(!this.commonHelper.phoneNumberValidator(this.company.payment.keyPix)){
//                 this.tostr.warning('CPF/CNPJ inválido.');
//                 this.company.payment.keyPix = "";
//             }
//             break;
//         case PixKeyType.email:
//             this.verifyEmailPixKey();
//             break;
//         case PixKeyType.cpf_cnpj:
//             this.verifyCPFCNPJPixKey();
//             break;
//         case PixKeyType.randomized:
//             this.randomPixKeySearch();
//             break;
//         default:
//             break;
//     }
//   }

//     onChangeMask() {
//         let typePix = this.company.payment.typePix;
//         switch (typePix) {
//             case PixKeyType.phone:
//                 this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
//                 break;
//             case PixKeyType.cpf_cnpj:
//                 let inputValue = this.company.payment.keyPix;
//                 if(!inputValue) return;

//                 if (inputValue && inputValue.length > 14)
//                     this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
//                 else
//                     this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
//                 break;
//             case PixKeyType.randomized:
//                 this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
//                 break;
//             default:
//                 break;
//         }
//     }

//     validateKeyPix(control: AbstractControl){
//         if(!control.value)
//             return {keyPix:true}
//         return null;
//     }

    async downloadPreview(event: any) {
        this.downloadUrl = await this.awsService.download(event);
    }

    companyValid(): boolean {
        if(!this.company.companyName || !this.company.address.street ||
            !this.company.address.number || !this.company.address.district ||
            !this.company.address.city || !this.company.address.uf ||
            this.company.address.uf == '0' || !this.company.cnpj ||
            !this.company.contracts || !this.typeContractModal) {

            this.tostr.warning('Há dados obrigatórios no documento ClickSign que não foram preenchidos. Verifique os campos: Nome Fantasia, Razão Social, CNPJ, dados de endereço e os campos do contrato a ser gerado.',
            'Formulário incompleto', {timeout: 5000});

            return false;
        };
        return true;
    };

    verifyFieldsForDocumentPreview(i: number, contract: CompanyContract): void {
        let selectedContractType = this.contractTypes.find(c => c.items.find(it => it.code == this.company.contracts[i].contractTypes.code));
        this.contractTypeGroup = selectedContractType.companyContractType;
        this.typeContractModal = String(this.contractTypeGroup);
        this.selectedContract = {...contract} as CompanyContract;
        this.company['contractStartAux'] = this.selectedContract.contractStart;

        if (this.companyValid() && this.verifySubscriberNameAndEmail()) {
            this.canPreviewDocument = true;
        } else {
            this.canPreviewDocument = false;
        };

    };

    verifySubscriberNameAndEmail() {
        const notAllowedSubscriberName = 1;

        if (this.company.emails.length == 0 ||
            this.company.subscriber == "" ||
            this.company.subscriberEmail == "" ||
            this.company.subscriber.split(' ').length <= notAllowedSubscriberName) {
            this.tostr.warning(`Por favor preencher com nome completo (Nome e Sobrenome) o campo 'RESPONSÁVEL PELA EMPRESA' e o campo 'E-MAIL DO RESPONSÁVEL PELA EMPRESA'.
            Além dos e-mails da empresa.`, 'Erro no formulário', {TimeOut: 6000});
            this.isSubscriberFieldEmpty = true;
            return false;
        } else {
            this.isSubscriberFieldEmpty = false;
            return true;
        }
    };


    getCompanyAndSignersData(signerModalCompanyData: Company): void {
        const company = signerModalCompanyData;
        const newContract = {...this.selectedContract} as CompanyContract;
        if (company && this.selectedContract) {
            this.generateContract(company, newContract);
        };
    };

  async generateContract(company: Company, contract: CompanyContract): Promise<void> {
    try {
        const newCompany = {...company};
        const newCompanyContract = {...contract};

        newCompanyContract.generated = true;
        newCompanyContract.generatedTemp = false;

        const lastContract = newCompany.contracts.length -1
        newCompany.contracts[lastContract].populateFromServer(newCompanyContract);

        this.company = {...newCompany} as Company;

        this.redirect = false;
        let companyUpdate = await this.OnSave();

        if(companyUpdate && companyUpdate._id) {
            this.tostr.success("Contrato gerado com sucesso");
            this.router.navigate(['/companies']);
        } else {
            this.errorHandler.interceptError(companyUpdate, 'Empresa');
        }
        this.loading = false;
    } catch (error) {
        this.loading = false;
        this.errorHandler.interceptError(error, 'Empresa');
    };
  };

  trimSubscriberData(): void {
      if (this.company.subscriber) this.company.subscriber = this.company.subscriber.trim();
      if (this.company.subscriberEmail) this.company.subscriberEmail = this.company.subscriberEmail.trim();
      if (this.company.financialEmail) this.company.financialEmail = this.company.financialEmail.trim();
  }

  validateLimitCaracters(limit: number, inputWord: string) {
    let strLength = inputWord.length
    this.restCaracters = limit

    while (this.restCaracters > 0) {
        this.restCaracters = this.restCaracters - strLength

        break
    }
  }

  convertDateStringToISO(date: string) {
    return `${date.substring(3, 5)}/${date.substring(0, 2)}/${date.substring(6, 11)}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/companies/companies-edit/companies-edit.component.ts